// extracted by mini-css-extract-plugin
export default {"masterContainer":"ScreenTimer_masterContainer__4ltca","ready":"ScreenTimer_ready__lvXVV"};